import { render, staticRenderFns } from "./WalletsFilter.vue?vue&type=template&id=54f77bb8&scoped=true"
import script from "./WalletsFilter.vue?vue&type=script&lang=js"
export * from "./WalletsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f77bb8",
  null
  
)

export default component.exports